<template>
  <AuthLayout img="https://cdn.landly.page/images/pulse/19 Coming soon.svg">
    <div slot="inner">
      <div style="max-width: 400px; margin: auto;">
        <v-card-title>
          <v-spacer />
          <span>Set Password</span>
          <v-spacer />
        </v-card-title>
        <v-form v-on:submit.prevent="trySetPassword">
          <v-text-field
            outlined
            dense
            label="Your E-mail"
            name="email"
            type="email"
            :disabled="true"
            :value="email"
            autocomplete="off"
          />
          <v-text-field
            outlined
            dense
            label="Full Name"
            name="fullName"
            type="text"
            v-model="fullName"
            autocomplete="off"
          />
          <v-text-field
            outlined
            dense
            label="Password"
            name="password"
            type="password"
            v-model="password"
            autocomplete="off"
          />
          <v-text-field
            outlined
            dense
            label="Password Repeat"
            name="passwordRepeat"
            type="password"
            v-model="passwordRepeat"
            autocomplete="off"
          />
          <small
            style="color: #696969"
          >Your password must have at least one digit, one alphanumeric and one uppercase character.</small>
          <div style="text-align: center" class="mt-3">
            <v-btn
              type="submit"
              color="primary"
              rounded
              :loading="setPasswordLoading"
              :disabled="!email || !password || !passwordRepeat || setPasswordLoading"
            >Set Password</v-btn>
          </div>
        </v-form>
      </div>
    </div>
  </AuthLayout>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import AuthLayout from "./AuthLayout";

export default {
  components: { AuthLayout },
  data() {
    return {
      email: "",
      fullName: "",
      password: "",
      passwordRepeat: ""
    };
  },
  computed: {
    ...mapState({
      setPasswordLoading: state => state.auth.setPasswordLoading
    })
  },
  methods: {
    ...mapMutations(["ALERT_SUCCESS", "ALERT_ERROR"]),
    ...mapActions("auth", ["setPassword"]),
    async trySetPassword() {
      if (!this.password || !this.passwordRepeat) return;
      if (!this.fullName) return;
      if (this.password !== this.passwordRepeat) {
        this.ALERT_ERROR("Passwords do not match");
        return;
      }
      const token = this.$route.query.token;
      const userId = this.$route.query.userId;
      this.setPassword({
        token,
        userId,
        password: this.password,
        fullName: this.fullName
      });
    }
  },
  async created() {
    document.title = "Set Password - Landly Console";
    this.email = this.$route.query.email;
  }
};
</script>